/**
 * @Desription: 登录-强制登录
 * @Author: netstar.sjj
 * @Date: 2021-10-26 14:05:00
 * @class strongLogin
*/
declare const window:any;
export default function(){
    let html:string = window.NSLogin.getConfirmHtml(window.language.login.strong);
    if(window.jQuery('#nsconfirm-modal-default-login').length == 1){
        window.jQuery('#nsconfirm-modal-default-login').remove();
    }
    window.jQuery('body').append(html);
    window.jQuery('#nsconfirm-modal-default-login button[type="button"]').on('click',function(ev){
        var nsType = window.jQuery(this).attr('ns-confirm-type');
        switch(nsType){
            case 'confirm':
                window.jQuery('#nsconfirm-modal-default-login').remove();
                window.NSLogin.loginManger.submit({forceFlag:1});
                break;
            case 'cancel':
                window.jQuery('#nsconfirm-modal-default-login').remove();
                break;
        }
    })
}